import { useSettings } from '@/context/SettingsContext';

// Inline SVG wordmark used when no custom logo_url is configured.
// Admin can override via Settings -> logo_url (any image URL).
export default function BrandLogo({ size = 'md' }) {
  const { settings } = useSettings();
  const dims = size === 'lg' ? 'h-10' : 'h-9';

  if (settings?.logo_url) {
    return (
      <img
        src={settings.logo_url}
        alt={settings.store_name || 'MyZippyKart'}
        className={`${dims} w-auto object-contain rounded-xl`}
        data-testid="brand-logo-img"
      />
    );
  }

  // Default MZK monogram badge
  return (
    <span
      data-testid="brand-logo-default"
      className={`${dims} aspect-square rounded-2xl grid place-items-center font-heading font-bold text-base shadow-sm`}
      style={{ backgroundColor: 'var(--app-primary, #0F8A43)', color: 'var(--app-button-text, #FFFFFF)' }}
    >
      MZK
    </span>
  );
}
